/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Highest tier among currently erroring contexts, or the overall highest tier when healthy
 * @export
 */
export const ControlHighestErrorTier = {
    Critical: 'critical',
    Medium: 'medium',
    Low: 'low',
    Unmonitored: 'unmonitored'
} as const;
export type ControlHighestErrorTier = typeof ControlHighestErrorTier[keyof typeof ControlHighestErrorTier];


export function ControlHighestErrorTierFromJSON(json: any): ControlHighestErrorTier {
    return ControlHighestErrorTierFromJSONTyped(json, false);
}

export function ControlHighestErrorTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlHighestErrorTier {
    return json as ControlHighestErrorTier;
}

export function ControlHighestErrorTierToJSON(value?: ControlHighestErrorTier | null): any {
    return value as any;
}

